export default __webpack_public_path__ + "static/media/MAXIS_1.635eac6a.gif";